import { inject, Injectable } from '@angular/core';
import { CampaignMeasure } from '../types/campaign.interface';
import { GraphMeasure } from '../types/graph-data.interface';
import { DateNavigationService } from './date-navigation.service';

@Injectable()
export class GraphMeasureSyncService {
  private readonly dateNav = inject(DateNavigationService);

  syncDateRangeFromMeasures(measures: GraphMeasure[]): void {
    if (measures.length === 0) {
      this.dateNav.setDates(null, null);
      return;
    }

    const { minDate, maxDate } = this.calculateDateRange(measures);
    if (minDate && maxDate) {
      this.dateNav.setDates(minDate, maxDate);
    }
  }

  calculateMinMaxForMeasure(values: CampaignMeasure[]): { min: Date | null; max: Date | null } {
    let minTime = Infinity;
    let maxTime = -Infinity;
    let hasValidDate = false;

    values.forEach(measure => {
      if (measure.timestamp) {
        const time = new Date(measure.timestamp).getTime();
        if (!isNaN(time)) {
          hasValidDate = true;
          if (time < minTime) minTime = time;
          if (time > maxTime) maxTime = time;
        }
      }
    });

    return hasValidDate ? { min: new Date(minTime), max: new Date(maxTime) } : { min: null, max: null };
  }

  private calculateDateRange(measures: GraphMeasure[]): { minDate: Date | null; maxDate: Date | null } {
    let minTime = Infinity;
    let maxTime = -Infinity;
    let hasValidDate = false;

    measures.forEach(measure => {
      if (measure.minTimestamp) {
        const time = measure.minTimestamp.getTime();
        if (!isNaN(time) && time < minTime) {
          minTime = time;
          hasValidDate = true;
        }
      }
      if (measure.maxTimestamp) {
        const time = measure.maxTimestamp.getTime();
        if (!isNaN(time) && time > maxTime) {
          maxTime = time;
          hasValidDate = true;
        }
      }
    });

    return hasValidDate ? { minDate: new Date(minTime), maxDate: new Date(maxTime) } : { minDate: null, maxDate: null };
  }
}
